<template>
  <div class="TopicDirectory">
    <div class="title">目录</div>
    <div class="topic-item">
      <div
        class="block"
        v-for="(topic, i) in T"
        :key="topic.questionId"
        @click="$emit('jumpTopic', i)"
      >
        <TopicBlock
          :highlight="activeIndex === i"
          :mark="displayMark(topic)"
          :index="topic.index"
        />
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import TopicBlock from "./TopicBlock.vue";
export default {
  name: "TopicDirectory",
  props: {
    T: {
      //所有题目
      type: Array,
      default: function() {
        return [];
      }
    },
    markType: {
      type: Number,
      default: 1 //灰色（未做），正确（绿勾），错误（红勾）,黄色（已做）的显示
      //1只标记已做未做。2只标记正确错误
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },

  data: function() {
    return {};
  },
  methods: {
    return0Or3Func(t) {
      if (t.type === 1 || t.type === 2) {
        if (t.userAnswer.length > 0) {
          return 3;
        } else {
          return 0;
        }
      } else {
        for (let i = 0; i < t.sonQuestion.length; i++) {
          let r = t.sonQuestion[i];
          if (r.userAnswer.length === 0) {
            //A3A4题里只要有一道小题未答，则该题视为未答
            return 0;
          }
        }
        return 3;
      }
    },
    return1Or2Func(t) {
      if (t.type === 1 || t.type === 2) {
        if (1 === t.answerType) return 1;
        if (2 === t.answerType) return 2;
        if (3 === t.answerType) return 2;
      } else {
        for (let i = 0; i < t.sonQuestion.length; i++) {
          let r = t.sonQuestion[i];
          if (2 === r.answerType) return 2; //只要其中一个错误就标记为错题
          if (3 === r.answerType) return 2; //只要其中一个未答就标记为错题
        }
        return 1; //正确
      }
    },
    displayMark(t) {
      // 做题的标记
      if (this.markType === 1) {
        //标记已做未做
        return this.return0Or3Func(t);
      }
      if (this.markType === 2) {
        //标记正确错误
        return this.return1Or2Func(t);
      }
    }
  },
  components: { TopicBlock }
};
</script>

<style lang="scss">
@import "@/assets/style/var.scss";
.TopicDirectory {
  width: 100%;
  height: 100%;
  padding: 28px;
  display: flex;
  flex-direction: column;
  .topic-item {
    flex: 1;
    margin: 24px 0;
    overflow-y: auto;
    .block {
      cursor: pointer;
      display: inline-block;
      width: 50%;
      overflow: hidden;
      border-bottom: 1px solid #f6f6f6;
      padding: 14px 0;
      &.active {
        color: $--color-primary;
      }
    }
  }
}
</style>
